import React, { useContext } from 'react';
import { PluginProps } from '../Plugin';
import { AuthContext, Role } from '../../../../../context/AuthProvider';
import { useQueryParam } from '../../../../../hooks/useQueryParams';
import CardFlip from '../../../../app/pages/InteractiveTest/components/CardFlip';

const FlipCard = (props: PluginProps) => {
  const { content } = props;
  const contentData = content.data;
  const user = useContext(AuthContext);
  const debugParam = useQueryParam('debug');

  const debug = user?.roles.includes(Role.staff) && !!debugParam;

  return (
    <CardFlip
      key={contentData.id}
      card={contentData.config}
      minWidth={content.data.min_width}
      width={content.data.width}
      maxWidth={content.data.max_width}
      minHeight={content.data.min_height}
      height={content.data.height}
      maxHeight={content.data.max_height}
      debug={debug}
    />
  );
};

export default FlipCard;
